<div class="row">
    <div class="col-md-12 col-lg-12 p-0">
        <div class="flight_det_button py-1 px-2">
            <div class="row" *ngIf="flight">
                <div class="col-md-12">
                    <a class="flightDetailsBtn" (click)="isCollapsed = !isCollapsed">
                        Flight Details&nbsp;&nbsp;
                        <i class="fa fa-angle-down"></i>
                    </a> &nbsp;&nbsp;
                </div>
            </div>
            <div class="row" style="margin: 0px -7px;" *ngIf="isCollapsed">
                <div class="col-md-12 col-lg-12 p-0">
                    <div [collapse]="" [isAnimated]="true">
                        <div class="bg-white">
                            <div class="col-md-12 text-justify">
                                <h6 class="bbottom" mat-dialog-title>
                                    {{ flight.FlightDetails.Details[0][0].Origin.CityName + '(' +
                                    flight.FlightDetails.Details[0][0].Origin.AirportCode + ')' }}
                                    <i
                                        class="{{ tripType == 'Roundtrip' ? 'fas fa-exchange-alt' : 'lnr-arrow-right'}}"></i>
                                    {{ flight.FlightDetails.Details[0][stops(flight)].Destination.CityName + '(' +
                                    flight.FlightDetails.Details[0][stops(flight)].Destination.AirportCode
                                    + ')' }}
                                </h6>
                                <tabset #tabset>
                                    <tab heading="ITINERARY">
                                        <app-flight-details-itinerary [flight]="flight"></app-flight-details-itinerary>
                                    </tab>

                                    <tab heading="BAGGAGE">
                                        <app-flight-details-baggage [flight]="flight"></app-flight-details-baggage>
                                    </tab>

                                    <tab heading="FARE BREAKUP & RULES">
                                        <app-flight-details-fare [flight]="flight"></app-flight-details-fare>
                                    </tab>
                                </tabset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>